import { BaseError } from '@libs/common-node';

import { CartUpdateError } from './cartBadRequestError';

export const CART_ERROR_CODES = {
    COUPON_ACTION_FAILURE: 'cart.couponactionfailure',
} as const;

// List of error messages to ignore
const ignoringRequests = [
    'Credit Card tokenization is rejected by psp',
    'AddDiscountCodeToCartCommand has failed validation.',
    'AddPaymentMethodToCartCommand',
];

// List of errorCodes that should be ignored
const ignoreCodes: string[] = [CART_ERROR_CODES.COUPON_ACTION_FAILURE];

/**
 * Determines whether the error should be ignored based on the error message or error code.
 * @param error - The error object
 * @returns boolean - True if the error should be ignored, false otherwise
 */
export const getShouldIgnoreError = (error?: unknown): boolean => {
    if (error instanceof CartUpdateError && error.errorDetails?.detail) {
        const includesIgnoringMessage = ignoringRequests.includes(error.errorDetails.detail);
        const responseErrors = Array.isArray(error.errorDetails.errors) ? error.errorDetails.errors : [];

        const includedIgnoreCode = responseErrors.some((err: BaseError) => ignoreCodes.includes(err.errorCode));

        return !!includesIgnoringMessage || !!includedIgnoreCode;
    }

    return false;
};
